import { Component, computed, input, output } from '@angular/core';
import { AngularModule } from '../../../../modules/angular.module';
import { ZorroModule } from '../../../../modules/zorro.module';

@Component({
	selector: 'app-cognito-group-selector',
	standalone: true,
	imports: [AngularModule, ZorroModule],
	templateUrl: './cognito-group-selector.component.html',
	styleUrl: './cognito-group-selector.component.scss',
})
export class CognitoGroupSelectorComponent {
	readonly allGroups = input<string[]>([]);
	readonly selectedGroups = input<string[]>([]);
	readonly onChange = output<string[]>();
	readonly groups = computed(() =>
		this.allGroups().filter(group => this.selectedGroups().includes(group))
	);

	public onSelectionChange(selectedGroups: string[]): void {
		const newGroups = this.allGroups().filter(group => selectedGroups.includes(group));
		this.onChange.emit(newGroups);
	}
}
